// @flow

import {
	GoogleMap,
	Marker,
	withGoogleMap,
	withScriptjs,
} from "react-google-maps";
import { compose, withProps } from "recompose";
import React from "react";
import styled from "styled-components";
import type { Node } from "react";

interface GoogleProps {
	googleMapURL: string;
	loadingElement: Node;
	containerElement: Node;
	mapElement: Node;
}

const googleProps: GoogleProps = {
	googleMapURL:
		"https://maps.googleapis.com/maps/api/js?key=AIzaSyAvA7_NR_8kmZOLYw6RBy0P4s0zPfHTf68",
	loadingElement: <div style={{ height: "100%" }} />,
	containerElement: <div style={{ height: "200px" }} />,
	mapElement: <div style={{ height: "100%" }} />,
};

interface Props {
	location: {
		lat: number,
		lng: number,
	};
}

const _GMapCard = ({ location }: Props) => {
	return (
		<GoogleMap
			defaultZoom={16}
			center={location}
			options={{
				zoomControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				mapTypeControl: false,
			}}
		>
			<Marker position={location} />
		</GoogleMap>
	);
};

const styledGMapCard = styled(_GMapCard)`
	width: 50%;
	height: 25%;
`;

const GMapCard = compose(
	withProps<any, GoogleProps>(googleProps),
	withScriptjs,
	withGoogleMap
)(styledGMapCard);

export default GMapCard;
